<k-card-content *transloco="let t;">
    <div class="sm:w-100 h-180 lg:w-120 flex flex-col items-center" style="width: 90vw; ">
        <div class="w-10/12 h-full flex flex-col items-center">
            <div class="w-40 pt-5">
                <img src="./assets/img/Icon/kmon-new-black.png" />
            </div>
            <p class="mt-15 text-3xl font-medium"> {{t(!isForgotPsw?'signIn.welcomeBack':'signIn.forgotPsw') |
                uppercase}}</p>
            <ng-container *ngIf="!isForgotPsw; else forgotPsw">
                <form class="w-full flex flex-col items-center" [formGroup]="signInFormGroup">
                    <!-- Form Control -->
                    <input class="w-full mt-6 mb-4" type="text" placeholder="Username" pInputText
                        formControlName="username" />
                    <input class="w-full" type="password" placeholder="Password" pInputText
                        formControlName="password" />

                    <div class="ml-auto mt-2 text-k-pink text-sm underline">
                        <a [href]="helpLink" target="_blank">{{t('signIn.needHelp')}}</a>
                    </div>
                    <!-- Submit for Form -->
                    <k-button type="submit" (onClickAction)="login()"
                        [isDisabled]="!signInFormGroup.valid">{{t('signIn.login')|uppercase}}</k-button>
                </form>
                <button type="button" (click)="isForgotPsw = true">
                    <p>{{t('signIn.forgotPswQ')}}</p>
                </button>
            </ng-container>
            <k-divider class="w-full mt-auto mb-9"></k-divider>
            <p>{{t('signIn.startFree')}}</p>
            <a class="mb-20" [routerLink]="'/sign-up'">
                <k-button>{{t('signIn.createAccont')}}</k-button>
            </a>
        </div>
    </div>
    <ng-template #forgotPsw>
        <form class="w-full flex flex-col items-center" [formGroup]="recoveryPassFormGroup">
            <input class="w-full mt-6 mb-4" type="text" placeholder="E-mail" pInputText formControlName="email" />
            <div class="flex">
                <k-button type="button" (onClickAction)="isForgotPsw = false" outline="true"
                    class="pr-3">{{t('shared.back')|uppercase}}</k-button>
                <k-button type="submit" (onClickAction)="forgotPassword()"
                    [isDisabled]="!recoveryPassFormGroup.valid">{{t('shared.confirm')|uppercase}}</k-button>
            </div>
        </form>
    </ng-template>
</k-card-content>